<template>
  <div>
    <v-toolbar fixed>
      <v-list-item>
        <img
          class="topbar-logo"
          src="../assets/logo-fullclean-top.png"
          alt="FullClean"
        />
      </v-list-item>
      <v-spacer></v-spacer>

      <!-- Menu desktop -->
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/dashboard"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-home</v-icon> <span class="menu-item-text">Inicio</span>
        </v-btn>

        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/formulario-dinamico"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-file-document-multiple-outline</v-icon>
          <span class="menu-item-text">Formularios dinámicos</span>
        </v-btn>

        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/solicitud-materiales"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-file-document-multiple-outline</v-icon>
          <span class="menu-item-text">Solicitud materiales</span>
        </v-btn>
        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/tickets"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-card-text-outline</v-icon>
          <span class="menu-item-text">Tickets</span>
        </v-btn>
        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/almacenamiento-archivo"
          v-if="user.level == 'admin' || 'user'"
        >
          <v-icon>mdi-card-plus</v-icon>
          <span class="menu-item-text">Almacenamiento de Archivos</span>
        </v-btn>
        <!-- <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-broom</v-icon> <span class="menu-item-text">Aseos</span>
        </v-btn> -->

        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/usuarios"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-account-group</v-icon>
          <span class="menu-item-text">Usuarios</span>
        </v-btn>

        <!-- <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-account-clock</v-icon>
          <span class="menu-item-text">Control de asistencia</span>
        </v-btn>

        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/programas-aseo"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-calendar-blank</v-icon>
          <span class="menu-item-text">Programada de aseo</span>
        </v-btn>

        <v-btn
          class="btn-menu-desktop"
          text
          router-link
          to="/"
          v-if="user.level == 'admin'"
        >
          <v-icon>mdi-toilet</v-icon>
          <span class="menu-item-text">Gestión de bolsas y baños</span>
        </v-btn> -->
      </v-toolbar-items>

      <!-- Menu mobile -->
      <div class="hidden-md-and-up">
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-app-bar-nav-icon v-bind="attrs" v-on="on"></v-app-bar-nav-icon>
          </template>
          <v-list>
            <v-list-item
              router-link
              to="/dashboard"
              v-if="user.level == 'admin'"
            >
              <v-list-item-action>
                <v-icon>mdi-home</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Inicio</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              router-link
              to="/formulario-dinamico"
              v-if="user.level == 'admin'"
            >
              <v-list-item-action>
                <v-icon>mdi-file-document-multiple-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Formularios Dinámicos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item router-link to="/tickets" v-if="user.level == 'admin'">
              <v-list-item-action>
                <v-icon>mdi-card-text-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Tickets</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            
            <v-list-item router-link to="/almacenamiento-archivo" v-if="user.level == 'admin'">
              <v-list-item-action>
                <v-icon>mdi-card-plus</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Almacenamiento de Archivos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
              router-link
              to="/programas-aseo"
              v-if="user.level == 'admin'"
            >
              <v-list-item-action>
                <v-icon>mdi-broom</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Programas de Aseo</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </div>

      <div class="btn-menu-cuenta">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="btn-menu-desktop b-0" v-bind="attrs" v-on="on">
              <v-icon>
                mdi-account-circle
              </v-icon>
              <div>
                <p class="text-usuario">{{ user.name }}</p>
                <p class="text-tipo-usuario">{{ user.level }}</p>
              </div>
              <v-icon>
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="clave = true">
              <v-list-item-action>
                <v-icon>mdi-key-variant</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Cambiar contraseña
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="salir()">
              <v-list-item-action>
                <v-icon>mdi-exit-to-app</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cerrar Sesión</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col>
          <router-view />
        </v-col>
      </v-row>
    </v-container>
    <!--<v-navigation-drawer v-model="right" fixed right temporary ></v-navigation-drawer>-->

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Mi cuenta:</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Nombre" required outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field label="Usuario" required outlined></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn text color="blue darken-1" @click="clave = true"
            >Cambiar Clave</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-1" @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn text color="blue darken-1" @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="clave"
      max-width="600px"
      :persistent="user.autopass == 0 ? true : false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Cambiar Contraseña</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="claveAnt"
                  label="Contraseña Actual"
                  :type="viewPass ? 'text' : 'password'"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col :cols="viewPass ? '12' : '6'">
                <v-text-field
                  v-model="claveNueva1"
                  label="Nueva Contraseña"
                  :type="viewPass ? 'text' : 'password'"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="6" v-if="!viewPass">
                <v-text-field
                  v-model="claveNueva2"
                  label="Repita la Nueva Contraseña"
                  type="password"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <password-meter :password="claveNueva1" @score="onScore" />
              </v-col>
              <ul>
                <li v-if="passMay">
                  <s>Debe contener al menos una Letra Mayuscula</s>
                </li>
                <li v-else>Debe contener al menos una Letra Mayuscula</li>

                <li v-if="passMin">
                  <s>Debe contener al menos una Letra Minuscula</s>
                </li>
                <li v-else>Debe contener al menos una Letra Minuscula</li>

                <li v-if="passNum"><s>Debe contener al menos un Numero</s></li>
                <li v-else>Debe contener al menos un Numero</li>

                <li v-if="passEsp">
                  <s
                    >Debe contener al menos un Caracter Especial
                    (._#?!@$%^*-)</s
                  >
                </li>
                <li v-else>
                  Debe contener al menos un Caracter Especial (._#?!@$%^*-)
                </li>

                <li v-if="passCar">
                  <s>Debe contener al menos 8 Caracteres</s>
                </li>
                <li v-else>Debe contener al menos 8 Caracteres</li>
              </ul>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-icon v-if="!viewPass" @click="viewPass = !viewPass">
            mdi-eye-off
          </v-icon>
          <v-icon v-else @click="viewPass = !viewPass">
            mdi-eye
          </v-icon>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="blue darken-1"
            v-if="user.autopass != 0"
            @click="clave = false"
            >Cancelar</v-btn
          >
          <v-btn
            text
            color="blue darken-1"
            @click="cambiarClave"
            v-if="
              passOk &&
                claveAnt.length > 0 &&
                (viewPass || claveNueva1 == claveNueva2)
            "
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
.btn-menu-cuenta .v-btn:not(.v-btn--round).v-size--default {
  background-color: #ffffff;
  min-height: 56px;
  border-radius: 0;
}
.btn-menu-cuenta .mdi-account-circle {
  font-size: 2rem !important;
}

.btn-menu-cuenta .mdi-chevron-down {
  font-size: 1.5rem !important;
  margin-left: 5px;
}

@media screen and (min-width: 960px) {
  .btn-menu-cuenta .v-btn:not(.v-btn--round).v-size--default {
    min-height: 64px;
  }
}
.btn-menu-desktop.v-btn {
  text-transform: none;
  letter-spacing: inherit;
  font-size: 0.9rem;
  font-weight: normal;
  box-shadow: none !important;
  border-right: 1px solid #cfcfcf;
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  width: auto;
  max-width: auto;
}
.btn-menu-desktop:hover.v-btn {
  width: fit-content;
}
.btn-menu-desktop.v-btn--active,
.btn-menu-desktop.v-btn--active i {
  color: #ffffff !important;
  font-weight: bold;
}
.btn-menu-desktop.v-btn--active:before,
.btn-menu-desktop.v-btn--active:hover:before {
  background: rgb(2, 75, 105);
  background: -moz-linear-gradient(
    151deg,
    rgba(2, 75, 105, 1) 24%,
    rgba(0, 158, 224, 1) 100%
  );
  background: -webkit-linear-gradient(
    151deg,
    rgba(2, 75, 105, 1) 24%,
    rgba(0, 158, 224, 1) 100%
  );
  background: linear-gradient(
    151deg,
    rgba(2, 75, 105, 1) 24%,
    rgba(0, 158, 224, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#024b69",endColorstr="#009ee0",GradientType=1);
  opacity: 1;
}
.btn-menu-desktop i {
  font-size: 1.2rem !important;
  color: rgba(0, 0, 0, 0.54) !important;
}
.b-0 {
  border: none !important;
}
.topbar-logo {
  max-width: 200px;
}
.v-avatar {
  width: 120px !important;
  height: auto !important;
  margin-bottom: 10px;
  margin-top: 10px;
}

.v-navigation-drawer__content {
  border-right: 1px solid #e2e2e2;
}

.text-usuario {
  margin-bottom: 0 !important;
  font-size: 0.9rem;
  font-weight: bold;
  padding-top: 16px;
}

.text-tipo-usuario {
  margin-bottom: 0 !important;
  color: #888888;
  padding-bottom: 16px;
  font-size: 0.8rem;
}
.no-shadow {
  box-shadow: none !important;
}
.btn-cuenta .mdi-account-circle {
  font-size: 2.3rem;
  padding-top: 22px;
}
.v-toolbar-header {
  border-radius: 4px;
}
.v-toolbar-header .v-toolbar__title {
  font-weight: bold;
}
.v-toolbar-header .v-toolbar__title i {
  position: relative;
  top: -2px;
}
.btn-principal {
  background-color: #ffffff !important;
  color: rgba(0, 0, 0, 0.54) !important;
}
.btn-principal.v-btn {
  /* text-transform: none; */
  letter-spacing: 0;
}

.btn-menu-desktop:hover .menu-item-text,
.btn-menu-desktop.v-btn--active .menu-item-text {
  display: block;
  width: fit-content;
  opacity: 1;
  margin-left: 5px;
  visibility: visible;
}

.btn-menu-desktop .menu-item-text {
  display: none;
  width: 0;
  opacity: 0;
  visibility: hidden;
}
</style>
<script>
import api from "../conf/ruta-base";
import axios from "axios";
import router from "../router";
import UserProfile from "../data";
import store from "../store";
import ImageInput from "../components/ImageInput";
import passwordMeter from "vue-simple-password-meter";
import swal from "sweetalert";
export default {
  name: "Home",
  components: { ImageInput, passwordMeter },
  props: {
    source: String,
  },
  data: () => ({
    user: UserProfile.getUserData(),
    avatar: null,
    drawer: true,
    drawerRight: false,
    right: false,
    left: false,
    barImage: "",
    imgLateral: false,
    score: 0,
    passReq: false,
    dialog: false,
    chosenFile: null,
    avatarTmp: null,
    clave: null,
    viewPass: false,
    claveAnt: "",
    claveNueva1: "",
    claveNueva2: "",
    imagenLateral: [
      { title: "Sin Imagen", imagen: "" },
      { title: "Actualidad", imagen: "sid3" },
      { title: "Nieve", imagen: "sid1" },
      { title: "Lago", imagen: "sid2" },
      { title: "Cordillera", imagen: "sid4" },
    ],
    passMay: false,
    passMin: false,
    passLen: false,
    passNum: false,
    passEsp: false,
    passCar: false,
    passOk: false,
  }),
  created() {
    if ((sessionStorage.token == undefined) | (sessionStorage.token == null)) {
      router.push("login");
    }
    if (this.user.autopass == 0) {
      this.clave = true;
    }
    if (localStorage.getItem("temaDark") == "true") {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
    if (localStorage.getItem("barImage")) {
      this.barImage = localStorage.getItem("barImage");
    }
  },
  mounted() {
    this.avatarTmp = ""; //this.user.emp.imagen_usuario
  },
  watch: {
    avatar() {
      this.avatarTmp = this.avatar.imageURL;
      this.chosenFile = this.avatar.imageFile;
    },
    claveNueva1(valor) {
      let bandera = 0;
      if (/(?=.*?[A-Z])/.test(valor)) {
        bandera++;
        this.passMay = true;
      } else {
        this.passMay = false;
      }
      if (/(?=.*?[a-z])/.test(valor)) {
        bandera++;
        this.passMin = true;
      } else {
        this.passMin = false;
      }
      if (/(?=.*?[0-9])/.test(valor)) {
        bandera++;
        this.passNum = true;
      } else {
        this.passNum = false;
      }
      if (/(?=.*?[#?!._@$%^&*-])/.test(valor)) {
        bandera++;
        this.passEsp = true;
      } else {
        this.passEsp = false;
      }
      if (valor.length >= 8) {
        bandera++;
        this.passCar = true;
      } else {
        this.passCar = false;
      }
      if (bandera > 4) {
        this.passOk = true;
      } else {
        this.passOk = false;
      }
    },
  },
  methods: {
    change() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("temaDark", this.$vuetify.theme.dark);
    },
    imagenbar(img) {
      if (img == "") {
        this.barImage = "";
        localStorage.setItem("barImage", "");
      } else {
        this.barImage = "img/" + img + ".jpg";
        localStorage.setItem("barImage", "img/" + img + ".jpg");
      }
      this.imgLateral = false;
    },
    salir() {
      sessionStorage.clear();
      router.push("/");
    },
    save() {
      let img = new FormData();
      let opt = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      if (this.chosenFile !== null)
        img.append("imagen", this.chosenFile, this.chosenFile.name);
      img.append("id", this.user.emp.id);
      img.append("nombres", this.user.emp.nombres);
      img.append("apellidos", this.user.emp.apellidos);
      img.append("api", api.api);
      axios
        .put(api.api + "empleado/micta", img, opt)
        .then((r) => {
          this.dialog = false;
          this.chosenFile = null;
          this.toast(r.data.c, r.data.mensaje);
          let usrdata = {
            nivel: r.data.level,
            nombre: r.data.nombres + " " + r.data.apellidos,
            emp: {
              apellidos: r.data.apellidos,
              id: r.data.id,
              idsupervisor: r.data.idsupervisor,
              iduser: r.data.id,
              imagen_usuario: r.data.imagen_usuario,
              nombres: r.data.nombres,
            },
          };
          UserProfile.setUserData(usrdata);
          this.user = usrdata;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    cambiarClave() {
      let params = {
        clave: this.claveAnt,
        clave_nueva: this.claveNueva1,
      };

      if (this.score <= 1) {
        swal(
          "",
          `La nueva clave es muy debil, favor ingrese una mejor clave`,
          "error"
        );
        return null;
      }

      if (!this.viewPass && this.claveNueva1 != this.claveNueva2) {
        swal("", `La nueva clave no coincide, favor verifiquelas`, "error");
        return null;
      }
      axios
        .put(api.api + "user/changepass", params)
        .then((res) => {
          this.toast(res.data.c, res.data.mensaje);
          if (res.data.c == "success") {
            this.claveAnt = "";
            this.claveNueva1 = "";
            this.claveNueva2 = "";
            this.clave = false;
            swal(
              "",
              `Por seguridad su session se cerrara y debera ingresar nuevamente`,
              "warning"
            ).then((ok) => {
              if (ok) this.salir();
            });
            setTimeout(this.salir, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onScore({ score, strength }) {
      this.score = score;
    },

    saludar(sal) {
      console.log(sal);
    },

    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },
  },
};
</script>
